export default {
  android: "https://play.google.com/store/apps/details?id=br.com.oidestinos",
  ios: "https://apps.apple.com/us/app/oi-destinos/id1552872659",
};
